import React, { FC } from 'react';
import { RoomOutlined } from '@material-ui/icons';
import { SheLocation, OnlineLocation } from '../../../types/location';
import './eventLocationLabel.module.scss';

type Props = {
  location: SheLocation | OnlineLocation;
};

export const EventLocationLabel: FC<Props> = ({ location }) => {
  return (
    <div styleName="label">
      <RoomOutlined styleName="icon" />
      {location ? location.short_name || location.name : 'オンライン'}
    </div>
  );
};
